export const SS_CLEAR_SELECTED_ANSWER = 'self_service/SS_CLEAR_SELECTED_ANSWER';
export const SS_QUICK_ACTIONS_FETCH_SUCCESS = 'self_service/SS_QUICK_ACTIONS_FETCH_SUCCESS';
export const SS_UPDATE_SEARCH_RESULTS_SUCCESS = 'self_service/SS_UPDATE_SEARCH_RESULTS_SUCCESS';
export const SS_UPDATE_SEARCH_TERM = 'self_service/SS_UPDATE_SEARCH_TERM';
export const SS_UPDATE_SELECTED_ANSWER = 'self_service/SS_UPDATE_SELECTED_ANSWER';
export const SS_UPDATE_SELECTED_ANSWER_SUCCESS = 'self_service/SS_UPDATE_SELECTED_ANSWER_SUCCESS';
export const SS_THROTTLE_CHAT = 'self_service/SS_THROTTLE_CHAT';
export const SS_UNTHROTTLE_CHAT = 'self_service/SS_UNTHROTTLE_CHAT';
export const UPDATE_RESULTS_SCROLLTOP = 'self_service/UPDATE_RESULTS_SCROLLTOP';

export const selfServiceEventTypes = {
  SS_CLEAR_SELECTED_ANSWER,
  SS_QUICK_ACTIONS_FETCH_SUCCESS,
  SS_UPDATE_SEARCH_RESULTS_SUCCESS,
  SS_UPDATE_SEARCH_TERM,
  SS_UPDATE_SELECTED_ANSWER,
  SS_UPDATE_SELECTED_ANSWER_SUCCESS,
  SS_THROTTLE_CHAT,
  SS_UNTHROTTLE_CHAT,
  UPDATE_RESULTS_SCROLLTOP,
};

export const updateAnswerSearchTerm = searchTerm => ({ type: SS_UPDATE_SEARCH_TERM, payload: searchTerm });
export const updateResultsScrollTop = scrollTop => ({ type: UPDATE_RESULTS_SCROLLTOP, payload: scrollTop });
export const updateSelectedAnswer = ({ answerId, answerName }) => ({
  type: SS_UPDATE_SELECTED_ANSWER,
  payload: { answerId, answerName },
});
export const updateSelectedAnswerSuccess = answer => ({ type: SS_UPDATE_SELECTED_ANSWER_SUCCESS, payload: { answer } });
export const updateSearchResultsSuccess = payload => ({ type: SS_UPDATE_SEARCH_RESULTS_SUCCESS, payload });
export const throttleSelfServiceChat = () => ({ type: SS_THROTTLE_CHAT });
export const unthrottleSelfServiceChat = () => ({ type: SS_UNTHROTTLE_CHAT });

export default {
  updateAnswerSearchTerm,
  updateResultsScrollTop,
  updateSelectedAnswer,
  updateSelectedAnswerSuccess,
  updateSearchResultsSuccess,
  throttleSelfServiceChat,
  unthrottleSelfServiceChat,
};
